import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    id: "backtotop",
    class: _normalizeClass({ active: _ctx.isTop }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToTop()))
  }, [...(_cache[1] || (_cache[1] = [
    _createElementVNode("i", { class: "ri-arrow-up-s-line" }, null, -1)
  ]))], 2))
}